import * as constants from './constants'

export const setStatu = (statu) => ({
  type: constants.SET_STATU,
  statu
})
